'use strict';

var has = require('has');
var Type = require('./Type');
var assertRecord = require('../helpers/assertRecord');

// https://262.ecma-international.org/5.1/#sec-8.10.1

module.exports = function IsAccessorDescriptor(Desc) {
  if (typeof Desc === 'undefined') {
    return false;
  }
  assertRecord(Type, 'Property Descriptor', 'Desc', Desc);
  if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
    return false;
  }
  return true;
};